import { render } from "./TheUserMenu.vue?vue&type=template&id=596538c0&scoped=true"
import script from "./TheUserMenu.vue?vue&type=script&lang=js"
export * from "./TheUserMenu.vue?vue&type=script&lang=js"

import "../css/adminlte.css?vue&type=style&index=0&id=596538c0&lang=css&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596538c0"]])

export default __exports__